import React from "react";
import { lazyWithRetry } from "utils/lazy-with-retry";

const LazyInitiatePaymentWizard = lazyWithRetry(
  () => import("./InitiatePaymentWizard"),
);

const InitiatePaymentWizard = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode },
) => <LazyInitiatePaymentWizard {...props} />;

export default InitiatePaymentWizard;
